import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useGetAccess } from "../../../common/hooks/useGetAccess/useGetAccess";
import { Routes } from "../../../routes";

function ProtectedRoute({ ...restOfProps }) {
  const { accessKey } = restOfProps;
  const { hasAccess, loading } = useGetAccess(accessKey);

  if (loading) {
    return null;
  }

  return hasAccess ? <Outlet /> : <Navigate to={Routes.badges} />;
}

export default ProtectedRoute;
